import { render, staticRenderFns } from "./ContactInfo.vue?vue&type=template&id=176a7f67&scoped=true"
import script from "./ContactInfo.vue?vue&type=script&lang=ts"
export * from "./ContactInfo.vue?vue&type=script&lang=ts"
import style0 from "./ContactInfo.vue?vue&type=style&index=0&id=176a7f67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176a7f67",
  null
  
)

export default component.exports